import { apiRequest } from '@/utils/api-request';
import * as Sentry from '@sentry/react';

// Only an ack that Temporal accepted the Signal; the authoritative paused
// state arrives over WS. Pausing while paused is a no-op, so firing on every
// keystroke is safe.
export interface PauseClarificationCountdownResponse {
  success: boolean;
  message: string;
  session_id: string;
  detail?: string;
}

/**
 * Pause the workflow's clarification countdown timer.
 *
 * Deliberately unretried: a dropped signal only means the BE timer keeps
 * counting while the FE shows a frozen visual.
 */
export const pauseClarificationCountdown = async (
  workflowId: string,
  sessionId: string,
  orgId: string,
): Promise<PauseClarificationCountdownResponse> => {
  try {
    const response = await apiRequest<PauseClarificationCountdownResponse>({
      url: `/api/v1/orgs/${orgId}/workflows/${workflowId}/runs/session/${sessionId}/pause-clarification-countdown`,
      method: 'POST',
      target: 'workflow',
    });
    if (response?.detail) {
      throw new Error(response.detail);
    }
    const data = (response?.data ?? response) as
      | PauseClarificationCountdownResponse
      | undefined;
    if (!data || data.success === false) {
      throw new Error(
        data?.detail ||
          data?.message ||
          'Pause-countdown signal was not accepted by the backend',
      );
    }
    return data;
  } catch (error) {
    Sentry.captureException(error, {
      extra: {
        context: 'pause-clarification-countdown',
        workflowId,
        sessionId,
      },
    });
    throw error;
  }
};
